import React from 'react'
import { Slide } from "react-awesome-reveal";


const RsvpSectionS3 = (props) => {
    return (
        <section className={`wpo-contact-section-s4 section-padding ${props.rClass}`} id="rsvp">
            <div className="wpo-contact-section-inner" style={{ background: `url(${props.bg}) no-repeat center top / cover` }}>
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col col-xl-5 col-lg-5 col-md-12 col-12">
                            <Slide direction="left" duration="1000" triggerOnce="true">
                                <div className="wpo-contact-section-wrapper">
                                    <div className="wpo-contact-form-area">
                                        <div className="wpo-section-title">
                                            <h2>
                                                <a style={{color: '#101010'}} href={'https://docs.google.com/forms/d/e/1FAIpQLSfq6-HZiDr1vE4jJwBc5xs55ZG4RykD5LgbH-dj0Mg2Nsb-UQ/viewform?usp=sf_link'}>
                                                    <u>
                                                        RSVP to our big day
                                                    </u>
                                                </a>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RsvpSectionS3;